import type { CollaborativeNote } from '../lib/types';

/**
 * Who a collaborative note belongs to and how many are on it, in the voice of the viewer.
 *
 * Collaborators are counted, not named: their `users/{uid}` documents are readable only by
 * them, so the uids are all there is. The owner is the one person a member can name, because
 * the note carries `ownerEmail`.
 */
export default function CollabMeta({ note, uid }: { note: CollaborativeNote; uid: string }) {
  const others = note.collaboratorIds?.length ?? 0;
  const mine = note.ownerId === uid;
  return (
    <>
      <span className="pill">{mine ? 'You own this' : `Shared by ${note.ownerEmail ?? 'its owner'}`}</span>
      {others > 0 && (
        <span>
          {others} collaborator{others === 1 ? '' : 's'}
        </span>
      )}
    </>
  );
}
